if (!customElements.get('form-validation')) {
    customElements.define('form-validation', class FormValidation extends HTMLElement {
      constructor() {
        super();
        this.phoneField = this.querySelector('input[type="tel"]');
        this.submitBtn = this.querySelector('button[type="submit"]');
        this.errors = [];
      }

      connectedCallback(){
        this.submitBtn.addEventListener('click', this.onFormSubmit.bind(this));
        this.phoneField.addEventListener('change', this.hideErrorMessage.bind(this, '.phone_error_message'));
      }

      isValidPhoneField(){
        const pattern = new RegExp(/^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g);
        return pattern.test(this.phoneField.value);
      }

      showErrorMessage(){
        this.errors.forEach(error => {
            const element = this.querySelector(error.ele);
            if(element){
                element.classList.add('show');
                element.textContent = error.message;
            }
        });
      }

      hideErrorMessage(ele){
        const element = this.querySelector(ele);
        if(element){
            element.classList.remove('show');
            element.textContent = '';
        }
      }

      onFormSubmit(event){
        this.errors = [];

        if(!this.isValidPhoneField()){
            this.errors.push({
                ele: '.phone_error_message',
                message: 'Please enter a valid phone number!'
            })
        }

        if(this.errors.length > 0){
            event.preventDefault();
            this.showErrorMessage();
        }
      }
    });
}
  